<template>
  <input type="date" v-model="editedModel" />
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    model: String
  },
  mounted() {
    // clone the model on mounted
    let fmt = 'YYYY-MM-DD';
    this.editedModel = this.model ? dayjs(this.model).format(fmt) : null;
  },
  watch: {
    editedModel: function() {
      if (!this.editedModel || this.editedModel === 'Invalid Date') {
        this.editedModel = null;
        console.log(this.editedModel);
        this.$emit('update:model', null);
      } else {
        // format and update the real model on edited model changed
        let dateFmt = 'YYYY-MM-DDTHH:mm:ssZ';
        let formatted = dayjs(this.editedModel).format(dateFmt);
        this.$emit('update:model', formatted);
      }
    }
  },
  data: () => ({
    editedModel: null
  })
};
</script>
